<ng-container *transloco="let t">
  <mat-toolbar class="tool-bar">
    <mat-toolbar-row fxLayout="row" fxLayoutAlign="start center">
      <h1> {{ t("user.assignSites") }}</h1>
      <span class="example-spacer"></span>
      <mat-icon mat-dialog-close>close</mat-icon>
    </mat-toolbar-row>
  </mat-toolbar>
  <mat-dialog-content>
    <div fxLayout="row wrap" class="padding-top-bottom-10">
      <div fxFlex="100">
        <mat-table
          [dataSource]="dataSource"
          class="propcentra-grid no-padding"
          *ngIf="hasRows"
        >
          <ng-container matColumnDef="select">
            <mat-header-cell *matHeaderCellDef>
              <mat-checkbox
                (change)="$event ? masterToggle() : null"
                [checked]="selection.hasValue() && isAllSelected()"
                [indeterminate]="selection.hasValue() && !isAllSelected()"
              >
              </mat-checkbox>
            </mat-header-cell>
            <mat-cell *matCellDef="let row">
              <mat-checkbox
                (click)="$event.stopPropagation()"
                (change)="$event ? selection.toggle(row) : null"
                [checked]="selection.isSelected(row)"
              >
              </mat-checkbox>
            </mat-cell>
          </ng-container>
          <ng-container matColumnDef="locationName">
            <mat-header-cell *matHeaderCellDef>
              {{ t("user.site") }}
            </mat-header-cell>
            <mat-cell *matCellDef="let element">
              <div>{{ element.locationName }}</div>
            </mat-cell>
          </ng-container>
          <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
          <mat-row *matRowDef="let row; columns: displayedColumns"></mat-row>
        </mat-table>
      </div>
      <div
        class="no-records-found"
        *ngIf="!hasRows"
        fxLayout="column"
        fxLayoutAlign="center center"
      ></div>
    </div>
  </mat-dialog-content>
  <div fxLayout="row" class="dialog-actions">
    <button
      mat-flat-button
      color="primary"
      [mat-dialog-close]="true"
      (click)="save()"
      cdkFocusInitial
    >
      {{ t("actions.Save") }}
    </button>
    <button mat-stroked-button mat-dialog-close>
      {{ t("actions.Cancel") }}
    </button>
  </div>
</ng-container>
